import { render } from "./ConfirmGenerateTokenModal.vue?vue&type=template&id=74c57a1d"
import script from "./ConfirmGenerateTokenModal.vue?vue&type=script&lang=js"
export * from "./ConfirmGenerateTokenModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__